import React, { useState, useEffect } from 'react';
import { Menu, X, Phone } from 'lucide-react';
import { Button } from './ui/button';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = ['Services', 'Download', 'Become a Vendor', 'Testimonials', 'Contact'];

  const scrollToSection = (section) => {
    let elementId = section.toLowerCase();
    // Handle special case for "Become a Vendor"
    if (section === 'Become a Vendor') {
      elementId = 'vendor-signup';
    }
    const element = document.getElementById(elementId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-black/95 backdrop-blur-md shadow-lg' : 'bg-black'
      }`}
    >
      <div className="container mx-auto px-4 py-2">
        <div className="flex items-center justify-between">
          {/* Phone Number - Far Left */}
          <a 
            href="tel:905-495-8888" 
            className="hidden sm:flex items-center gap-2 text-white hover:text-yellow-400 transition-colors duration-200 mr-6"
            data-testid="header-phone"
          >
            <Phone size={16} />
            <span className="font-medium text-sm">905-495-8888</span>
          </a>

          <div className="flex items-center">
            <div className="flex items-center space-x-3">
              <img 
                src="/logo.svg" 
                alt="bHyyve Logo" 
                className="w-16 h-16 object-contain"
              />
              <span className="text-2xl font-bold text-white">bHyyve</span>
            </div>

            {/* Desktop Navigation */}
            <nav className="hidden md:flex items-center space-x-8 ml-16">
              {navLinks.map((link) => (
                <button
                  key={link}
                  onClick={() => scrollToSection(link)}
                  className="text-white hover:text-yellow-400 transition-colors duration-200 font-medium"
                >
                  {link}
                </button>
              ))}
              <Button
                className="bg-yellow-400 text-black hover:bg-yellow-500 font-semibold"
                onClick={() => scrollToSection('download')}
              >
                Get Started
              </Button>
            </nav>
          </div>

          {/* Tagline - Right side */}
          <div className="hidden lg:flex items-center">
            <span className="text-yellow-400 font-bold text-sm">
              Federally registered Canadian Technology Company.
            </span>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-white ml-auto"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <nav className="md:hidden mt-4 pb-4 flex flex-col space-y-4">
            {/* Phone Number in Mobile Menu */}
            <a 
              href="tel:905-495-8888" 
              className="flex items-center gap-2 text-white hover:text-yellow-400 transition-colors duration-200"
            >
              <Phone size={16} />
              <span className="font-medium">905-495-8888</span>
            </a>
            {navLinks.map((link) => (
              <button
                key={link}
                onClick={() => scrollToSection(link)}
                className="text-white hover:text-yellow-400 transition-colors duration-200 font-medium text-left"
              >
                {link}
              </button>
            ))}
            <Button
              className="bg-yellow-400 text-black hover:bg-yellow-500 font-semibold w-full"
              onClick={() => scrollToSection('download')}
            >
              Get Started
            </Button>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;